var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "regist-content flex align-center justify-center bg-white" },
    [
      _vm.step == 1
        ? _c(
            "div",
            { staticClass: "pb-30 text-center" },
            [
              _c("h3", { staticClass: "mb-10" }, [_vm._v("选择您运营的项目")]),
              _vm._v(" "),
              _c("div", { staticClass: "mb-30 fs-s3" }, [
                _vm._v("至少选择一个，可以多选"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mb-30 flex flex-wrap" },
                _vm._l(_vm.platform.device_type, function (item) {
                  return _c(
                    "div",
                    {
                      staticClass: "pl-20 pr-20 cursor",
                      on: {
                        click: function ($event) {
                          return _vm.selDevice(item)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "rel text-grey" },
                        [
                          _c("el-avatar", {
                            attrs: {
                              size: 150,
                              fit: "cover",
                              shape: "square",
                              src: "/product/" + item.depend_type + ".jpg",
                            },
                          }),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "abs el-icon-success fs-b3",
                            class: {
                              "text-primary":
                                _vm.selType.indexOf(item.depend_type) > -1,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-10" }, [
                        _vm._v(_vm._s(item.depend_name)),
                      ]),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _vm.selType.length == 0
                ? _c(
                    "el-button",
                    {
                      staticClass: "mb-40 mt-30 fs-b1",
                      attrs: { type: "primary", round: "" },
                    },
                    [_vm._v("    请选择运营项目    ")]
                  )
                : _c(
                    "el-button",
                    {
                      staticClass: "mb-40 mt-30 fs-b1",
                      attrs: { type: "primary", round: "" },
                      on: {
                        click: function ($event) {
                          _vm.step = 2
                        },
                      },
                    },
                    [
                      _vm._v("        下一步"),
                      _c("i", { staticClass: "ml-5 el-icon-right fs-b1" }),
                      _vm._v("        "),
                    ]
                  ),
              _vm._v(" "),
              _c("h4", { staticClass: "mb-30" }, [_vm._v("即将上线")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mb-30 flex flex-wrap justify-center" },
                _vm._l(_vm.soon, function (item) {
                  return _c(
                    "div",
                    {
                      staticClass: "pl-20 pr-20 cursor",
                      on: {
                        click: function ($event) {
                          return _vm.selDevice(item)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "rel text-grey" },
                        [
                          _c("el-avatar", {
                            attrs: {
                              size: 100,
                              fit: "cover",
                              shape: "square",
                              src: "/product/" + item.depend_type + ".jpg",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-10 fs-s3" }, [
                        _vm._v(_vm._s(item.depend_name)),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.step == 2
        ? _c("div", { staticClass: "info-content pb-30 text-center" }, [
            _c("h3", { staticClass: "mb-10" }, [_vm._v("完善您的个人资料")]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-30 fs-s3" }, [
              _vm._v("方便我们进行更深入的合作"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              [
                _c(
                  "el-form",
                  {
                    ref: "form",
                    attrs: { model: _vm.form, "label-width": "0" },
                  },
                  [
                    _c("upload", {
                      staticClass: "mb-20",
                      model: {
                        value: _vm.form.avatar,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "avatar", $$v)
                        },
                        expression: "form.avatar",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { placeholder: "公司名称" },
                          model: {
                            value: _vm.form.company_name,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "company_name", $$v)
                            },
                            expression: "form.company_name",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      [
                        _c("v-distpicker", {
                          staticClass: "flex",
                          attrs: {
                            province: _vm.form.charge_province,
                            city: _vm.form.charge_city,
                            area: _vm.form.charge_county,
                          },
                          on: { selected: _vm.selectCity },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { placeholder: "公司地址" },
                          model: {
                            value: _vm.form.company_address,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "company_address", $$v)
                            },
                            expression: "form.company_address",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("h4", { staticClass: "pt-10 text-left" }, [
                      _vm._v("个人信息"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { placeholder: "您的姓名" },
                          model: {
                            value: _vm.form.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "name", $$v)
                            },
                            expression: "form.name",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { placeholder: "您的身份证号码" },
                          model: {
                            value: _vm.form.id_card,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "id_card", $$v)
                            },
                            expression: "form.id_card",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex justify-center" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "mb-30 mt-40 fs-b1",
                    attrs: { type: "info", round: "" },
                    on: {
                      click: function ($event) {
                        _vm.step = 1
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "ml-5 el-icon-back fs-b1" }),
                    _vm._v("上一步"),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "mb-30 mt-40 fs-b1",
                    attrs: { type: "primary", round: "" },
                    on: {
                      click: function ($event) {
                        return _vm.editInfo()
                      },
                    },
                  },
                  [_vm._v("    开始试用    ")]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }